import { useState, useEffect } from 'react';

const navItems = [
  { label: '深度爆料', href: '#cards' },
  { label: '读者热议', href: '#comments' },
  { label: '热门视频', href: '#media' },
  { label: 'APP下载', href: '#app' },
  { label: '热搜榜单', href: '#ranking' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1440px] mx-auto">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="flex items-center gap-2 shrink-0 cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-fire-fill text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-bold text-foreground-900 font-heading whitespace-nowrap">
              网红爆料
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-lg whitespace-nowrap cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-lg whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer text-foreground-700"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <nav className="flex flex-col px-4 py-3 gap-1 max-w-[1440px] mx-auto">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setMobileOpen(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-lg cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-lg cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}